export default __webpack_public_path__ + "static/signature-logo-eb8fc2268f8e0d6a73e2cd4e261a8dbb.mp4";